<nav>
  <ul class="head-menu">
    <li class="head-menu__item" *ngFor="let item of list">
      <a
        *ngIf="hasLink else isNotLinkTmpl"
        [routerLink]="item.link"
        class="link"
        routerLinkActive="active"
        [attr.data-qa]="'dashboard.account-tab.button-' + (item.translateKey | translate)"
      >{{ (item.translateKey | translate) + (item.postfix || '') }}</a>
      <ng-template #isNotLinkTmpl>
        <button
          (click)="select(item)"
          [class.active]="item.active"
          class="link"
          [attr.data-qa]="'dashboard.account-tab.button-' + (item.translateKey | translate)"
        >{{ (item.translateKey | translate) + (item.postfix || '') }}</button>
      </ng-template>
    </li>
  </ul>
</nav>
